<div id="keyboard-div">
  <div id="keyboard-modal">
    <div id="keyboard">
      <div id="input-container">
        <input
          disabled="true"
          ngbAutofocus
          class="form-control"
          [innerHTML]="value"
          #keyValue
          id="input-value"
          type="text"
          [(ngModel)]="value"
        />
      </div>
      <div id="keyboard-container">
        <button
          (click)="onKeyClick(key)"
          *ngFor="let key of keys; let i = index"
          class="btn keyboard-key"
          [ngClass]="{
            'btn-108 ': key != okKey,
            'ok-key': key == okKey,
            'btn-c': key == 'Close'
          }"
          [innerHTML]="key"
        ></button>
      </div>
    </div>
  </div>
</div>
